// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-product__list-loading{color:rgba(255,255,255,.3);font-size:14px;display:flex;flex-direction:column;justify-content:center;align-items:center}.plv-iar-product__list-loading__icon{font-size:32px;animation:spin 1s ease infinite;margin-bottom:8px;display:flex}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
